<template>
  <div v-if="periodos" :class="['col-xs-12', `col-md-${size}`]">
    <form-group-search-select
      ref="input"
      :label="label"
      :readonly="readonly"
      :value="value"
      :name="name"
      :options="periodos"
      :data-vv-as="label"
      :placeholder="placeholder"
      @input="$emit('input', $event)"
      @change="$emit('input', $event)"
      v-validate="{ required: required }"
    />
  </div>
</template>

<script>
export default {
  name: "c-protocolo-periodo-multiplo",
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator"],
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    size: {
      type: String,
      default: "6"
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean
  },
  mounted() {
    this.$el.value = this.value;
  },
  computed: {
    periodos() {
      let perletivos = [];
      for (let i = this.$moment().format("YYYY"); i >= 2004; i--) {
        perletivos.push({ value: `${i}/2`, text: `${i}/2` });
        perletivos.push({ value: `${i}/1`, text: `${i}/1` });
      }
      return perletivos;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/Campos/PeriodoMultiplo.vue